import { Breadcrumb } from 'antd'
import { faHouse } from '@fortawesome/free-solid-svg-icons'
import RenderIf from '@common/RenderIf'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { TRouteItems } from 'types/routes'


export const RouteBreadcrumbs = ({ routeItems }: {
    routeItems: TRouteItems
}) => {
    // Добавляем крошку для перехода на главную
    // const routeItemsExtended = [
    //     {
    //         path: '/lk/admin',
    //         title: '',
    //         breadcrumb: '',
    //         icon: faHouse,
    //     },
    //     ...routeItems,
    // ]
    
    return (
        <Breadcrumb>
            {
                routeItems.map((data) => (
                    <Breadcrumb.Item key={data.path}>
                        <Link to={data.path} style={{display: 'inline-block', paddingBlock: '3px'}}>
                            <RenderIf condition={data.icon}>
                                <FontAwesomeIcon
                                    style={{marginRight: '5px'}}
                                    icon={data.icon as IconDefinition}
                                />
                            </RenderIf>
                            {data.breadcrumb}
                        </Link>
                    </Breadcrumb.Item>
                ))
            }
        </Breadcrumb>
    )
}
